import styled from 'styled-components';

export const TestimonialsContainer = styled.section`
  background: #f9fbfd;
  padding: 100px 20px;
  text-align: center;
  min-height: 600px;
  scroll-margin-top: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media screen and (max-width: 1024px) {
    min-height: 500px;
  }

  @media screen and (max-width: 768px) {
    min-height: 450px;
  }

  @media screen and (max-width: 480px) {
    min-height: 400px;
  }
`;

export const TestimonialsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;         /* sorgt dafür, dass alle Cards gleich hoch werden */
  gap: 40px;
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 20px;

  @media screen and (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const TestimonialCard = styled.div`
  background: #ffffff;
  border-radius: 12px;
  padding: 40px 30px;
  box-shadow: 0 6px 18px rgba(0,0,0,0.08);
  flex: 1;                      /* nimmt gleichen Platz ein */
  display: flex;                /* Inhalt gleichmäßig verteilen */
  flex-direction: column;       /* Text oben, Autor unten */
  justify-content: space-between; 
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 24px rgba(0,0,0,0.12);
  }
`;

export const TestimonialText = styled.p`
  font-style: italic;
  font-size: 1.05rem;
  color: #333;
  margin-bottom: 20px;
  line-height: 1.6;
  flex-grow: 1;   /* füllt den Platz zwischen Card-Anfang und Autor */
`;

export const Author = styled.span`
  display: block;
  font-weight: bold;
  color: #555;
  margin-top: 10px;
  font-size: 0.95rem;
`;

export const FadeInSection = styled.div`
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  transform: ${({ isVisible }) => (isVisible ? 'translateY(0)' : 'translateY(40px)')};
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
`;
